import { render, staticRenderFns } from "./schoolPrinciple.vue?vue&type=template&id=4a4eb17c&scoped=true&"
import script from "./schoolPrinciple.vue?vue&type=script&lang=js&"
export * from "./schoolPrinciple.vue?vue&type=script&lang=js&"
import style0 from "./schoolPrinciple.vue?vue&type=style&index=0&id=4a4eb17c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4eb17c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VLayout,VRow,VSelect,VTextField})
